<template>
<!--    <div class="calendar--day--event" v-bind:style="[selectedDate && selectedDate.current_fix_tickets_stock > 0 ? {cursor: 'pointer'} : {cursor: 'default'}]"> -->
    <div class="calendar--day--event" v-bind:style="[{cursor: 'pointer'}]">
        <div v-html="event.template" v-if="event.template"></div>
<!--        <div v-else>
            <div v-if="selectedDate">
                <div v-if="selectedDate.current_fix_tickets_stock >= 400">
                    <span class="badge badge-success">Stock alto</span>
                </div>
                <div v-else-if="selectedDate.current_fix_tickets_stock > 100 && selectedDate.current_fix_tickets_stock < 400">
                    <span class="badge badge-warning">Stock medio</span>
                </div>
                <div v-else-if="selectedDate.current_fix_tickets_stock <= 100 && selectedDate.current_fix_tickets_stock > 0">
                    <span v-if="selectedDate.current_fix_tickets_stock <= 50" class="badge badge-danger">Stock bajo: {{selectedDate.current_fix_tickets_stock}}</span>
                    <span v-else class="badge badge-danger">Stock bajo</span>

                </div>
                <div v-else-if="selectedDate.current_fix_tickets_stock == 0">
                    <span class="badge badge-dark">Sin stock</span>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        props: {
            event: {
                type: Object,
                default() {
                    return {};
                }
            }
        },

        computed: {
            desc() {
                return this.event.desc ? `${this.event.desc}% desc` : '';
            },
            selectedDate() {
                return this.$store.state.stockDate.find(stock_date => stock_date.date == this.event.date);
            }
        }
    }
</script>

<style>
    .calendar--day--event {
        height: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CalendarDayEvent.vue